import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import api from "../../../core/api/config";
import { capitalizarTexto } from "../../../shared/utils/formatador";
import { calcularIdade } from "../../../shared/utils/calcularIdade";

const TabHistoricoOrganograma = ({ patientId, paciente, dadosCompletos }) => {
  const [historico, setHistorico] = useState([]);
  const dataNascimento = dadosCompletos?.dataNascimento || "Sem informação";
  const tipoRastreamento = dadosCompletos?.tipoControle || "—";

  useEffect(() => {
    if (patientId) carregarHistorico();
  }, [patientId]);

  const carregarHistorico = async () => {
    try {
      const { data } = await api.get(
        `/api/tracking/patient/${patientId}/edicao`,
      );

      const ordenado = (data?.historicoOrganograma || []).sort(
        (a, b) => new Date(b.data) - new Date(a.data),
      );

      setHistorico(ordenado);
    } catch (err) {
      console.error("Erro ao carregar histórico:", err);
    }
  };

  const formatarData = (dataISO) => {
    if (!dataISO) return "—";
    const data = new Date(dataISO);
    return data.toLocaleDateString("pt-BR");
  };

  if (!historico.length) {
    return <div>Nenhum histórico encontrado.</div>;
  }

  const maisRecente = historico[0];
  const historicoAnterior = historico.slice(1);

  return (
      <div className="historico-organograma">
        <div className="dados-pessoais p-3 d-grid gap-4">
          <div className="row g-3">
            <div className="col-12 col-md-3">
              <div className="text-muted small mb-1">Paciente</div>
              <div className="fw-semibold text-dark">
                {capitalizarTexto(paciente.nome) || "—"}
              </div>
            </div>

            <div className="col-6 col-md-2">
              <div className="text-muted small mb-1">ID</div>
              <div className="fw-semibold">{paciente.id || "—"}</div>
            </div>

            <div className="col-6 col-md-2">
              <div className="text-muted small mb-1">Data de nascimento</div>
              <div className="fw-semibold">{formatarData(dataNascimento)}</div>
            </div>

            <div className="col-6 col-md-2">
              <div className="text-muted small mb-1">Idade</div>
              <div className="fw-semibold">{calcularIdade(dataNascimento)}</div>
            </div>

            <div className="col-6 col-md-3">
              <div className="text-muted small mb-1">Tipo de Rastreamento</div>
              <div className="fw-semibold">{tipoRastreamento}</div>
            </div>
          </div>
        </div>
        <div className="organograma-atual p-3 d-grid gap-4">
          <div className="row g-2 mb-3">
            <div className="col-md-12">
              <h5>Organograma Atual</h5>
              <hr />
            </div>
            <div className="col-md-4">
              <strong>Organograma</strong>
              <div>
                {capitalizarTexto(maisRecente.descricaoOrganograma) || "—"}
              </div>
            </div>

            <div className="col-md-4">
              <strong>Hierarquia</strong>
              <div>{capitalizarTexto(maisRecente.hierarquia) || "—"}</div>
            </div>

            <div className="col-md-4">
              <strong>Data</strong>
              <div>{formatarData(maisRecente.data)}</div>
            </div>
          </div>
        </div>

        <div className="historico p-3 d-grid gap-4">
          {historicoAnterior.length > 0 && (
            <div>
              <div className="col-md-12">
                <h5>Histórico de Alterações</h5>
                <hr />
              </div>

              <div className="table-responsive">
                <table className="table table-sm table-bordered table-hover">
                  <thead className="thead-light">
                    <tr>
                      <th>Organograma</th>
                      <th>Hierarquia</th>
                      <th>Data</th>
                    </tr>
                  </thead>

                  <tbody>
                    {historicoAnterior.map((item) => (
                      <tr key={item.idHistorg}>
                        <td>
                          {capitalizarTexto(item.descricaoOrganograma) || "—"}
                        </td>

                        <td>{capitalizarTexto(item.hierarquia) || "—"}</td>

                        <td>{formatarData(item.data)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
  );
};

TabHistoricoOrganograma.propTypes = {
  patientId: PropTypes.number,
  paciente: PropTypes.object,
  dadosCompletos: PropTypes.object,
};

export default TabHistoricoOrganograma;
